module.exports = __webpack_public_path__ + "static/media/31.10.ba5b7091.webp";